import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  total: {
    defaultMessage: 'Total',
  },
  totalLong: {
    defaultMessage: 'Total score',
  },
  bonusShort: {
    defaultMessage: '+%',
  },
  bonusLong: {
    defaultMessage: 'Bonus points',
  },
  actualGameStat: {
    defaultMessage: 'Actual: {gameStat}',
  },
  fantasyGameScore: {
    defaultMessage: 'Fantasy: {gameStat}',
  },
  noGames: {
    defaultMessage: 'No games',
  },
});
